import { render, staticRenderFns } from "./FilterAccordion.vue?vue&type=template&id=4945ab7b&scoped=true&"
import script from "./FilterAccordion.vue?vue&type=script&lang=js&"
export * from "./FilterAccordion.vue?vue&type=script&lang=js&"
import style0 from "./FilterAccordion.vue?vue&type=style&index=0&id=4945ab7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4945ab7b",
  null
  
)

export default component.exports